import { CONVERSATIONS_LOADER, DASHBOARD_LOADER, MESSAGES_LOADER } from "../action-types/loaderActionTypes";

export function updateConversationsLoader(payload: any) {
    return {
        type: CONVERSATIONS_LOADER,
        payload: payload
    }
}

export function updateMessagesLoader(payload: any) {
    return {
        type: MESSAGES_LOADER,
        payload: payload
    }
}

export function updateDashboardLoader(payload: any) {
    return {
        type: DASHBOARD_LOADER,
        payload: payload
    }
}